module.exports = __webpack_public_path__ + "img/cassa-portatile.ead8a124.jpg";